import css from 'styled-jsx/css';
import { colors, icons } from '../../../config/styles';
import { svgToDataUri } from '../../../utils/styles/svgMixins';

export const SubMenuStyles = css`
  .sub-header {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    align-items: center;
    gap: 8px;
    @media (max-width: 600px) {
      justify-content: space-around;
    }
    &.zone-header-screen {
      @mixin mobileToTablet {
        justify-content: flex-start;
      }
    }
  }
  .zone-selected {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 32px;
    max-width: 406px;
    padding: 20px 0;
    width: 80%;
  }
  .zone-change {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-decoration: underline;
    display: flex;
    align-items: center;
    height: 32px;
    border-radius: 5px;
    opacity: 90%;
    max-width: 100%;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:first-child {
        width: 100%;
      }
    }

    .arrow_down {
      background-image: url('/a/fa/product/static/styles/svg/HeaderIcons/arrow.svg');
      width: 17px;
      height: 17px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      margin-left: 4px;
    }
  }
  .zone-change.map-view {
    @media (max-width: 600px) {
      border-radius: 280px;
      background: rgba(249, 249, 249, 0.9);
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
      display: flex;
      height: 32px;
      max-width: 100%;
      max-height: 32px;
      padding: 0px 32px;
      justify-content: center;
      align-items: center;
    }
  }
  .view-button {
    display: flex;
    gap: 6px;
    @mixin tabletToDesktop {
      display: none;
    }
  }

  .map-view-btn {
    background-image: url('${svgToDataUri(icons.mapsViewIcon)}');
    display: flex;
    width: 32px;
    height: 32px;
    max-width: 32px;
    max-height: 32px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 280px;
    background-color: #fefeff;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    background-position: center;
    background-repeat: no-repeat;
    border: 1.5px solid ${colors.gray.shade14};

    &.active {
      border: 1.5px solid #343e49;
      background-image: url('${svgToDataUri(icons.mapsViewIconActive)}');
    }
  }
  .list-view-btn {
    background-image: url('${svgToDataUri(icons.listViewIcon)}');
    display: flex;
    width: 32px;
    height: 32px;
    max-width: 32px;
    max-height: 32px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 280px;
    background-color: #fefeff;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    background-position: center;
    background-repeat: no-repeat;
    border: 1.5px solid ${colors.gray.shade14};
    &.active {
      border: 1.5px solid #343e49;
      background-image: url('${svgToDataUri(icons.listViewIconActive)}');
    }
  }
`;
